import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { QuoteToolLiteStore } from '../../store';
import { DateFormat } from '@lx/shared/i18n';
import { CourseDetails } from '@lx/quote-tool/lite/shared/types';
import { SchoolLocation } from '@lx/quote-tool/lite/shared/types';
import { StudyPeriodPipe } from '@lx/quote-tool/lite/shared/ui/pipes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DurationUnitEnum } from '@lx/shared/data-access/types';
import { Flows } from '@lx/quote-tool/lite/shared/types';

@Component({
  standalone: true,
  selector: 'lx-course-summary',
  templateUrl: './course-summary.component.html',
  styleUrls: ['./course-summary.component.scss'],
  imports: [StudyPeriodPipe],
})
export class CourseSummaryComponent implements OnInit {
  schoolLocation: SchoolLocation | undefined;
  course: CourseDetails | undefined;
  startDate = '';
  endDate = '';
  duration = 0;
  activeFlow = '';

  protected readonly Flows = Flows;
  protected readonly dateFormat = DateFormat;
  protected readonly DurationUnitEnum = DurationUnitEnum;

  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.quoteToolLiteStore.courseDetails$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ selectedSchoolLocation, selectedCourse, selectedDuration, selectedStartDate, selectedEndDate, activeFlow }) => {
        this.schoolLocation = selectedSchoolLocation;
        this.course = selectedCourse;
        this.duration = selectedDuration;
        this.startDate = selectedStartDate;
        this.endDate = selectedEndDate;
        this.activeFlow = activeFlow;
      });
  }
}
